import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Expertise } from './pages/Expertise';
import { Experience } from './pages/Experience';
import { Advisory } from './pages/Advisory';
import { ThoughtLeadership } from './pages/ThoughtLeadership';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2riko97zkgfcl">
      <Routes data-id="element-1" data-mp="2mm2lgdnsqr2w">
        <Route element={<Layout data-id="element-3" data-mp="2mmvk0rclqa9y" />} data-id="element-2" data-mp="2mmlt91jqfz37">
          <Route path="/" element={<Home data-id="element-5" data-mp="2mjzo18kbdvo5" />} data-id="element-4" data-mp="2mndna7xolord" />
          <Route path="/about" element={<About data-id="element-7" data-mp="31brzvakwgrl4" />} data-id="element-6" data-mp="31agpgrwy8ll1" />
          <Route path="/expertise" element={<Expertise data-id="element-9" data-mp="2wk0bn6p7uxy5" />} data-id="element-8" data-mp="31c1i2bzpdug9" />
          <Route path="/experience" element={<Experience data-id="element-11" data-mp="2wifbn1k4umsw" />} data-id="element-10" data-mp="2wjqgz5t882m4" />
          <Route path="/advisory" element={<Advisory data-id="element-13" data-mp="28tmex2vosax8" />} data-id="element-12" data-mp="2wi5m1f302hnq" />
          <Route path="/thought-leadership" element={<ThoughtLeadership data-id="element-15" data-mp="23vciyq2516ak" />} data-id="element-14" data-mp="28t4k8aooa4rf" />
          <Route path="/contact" element={<Contact data-id="element-17" data-mp="23ut97wmn5o7m" />} data-id="element-16" data-mp="23w4ey1znd61d" />
          <Route path="*" element={<Home data-id="element-19" data-mp="3ik7jmqgv0tve" />} data-id="element-18" data-mp="23ti7e2craqj5" />
        </Route>
      </Routes>
    </BrowserRouter>;
}